import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import apiService from '../../api/ApiService'
import SinglePI from './SunglePI'
import { Col, Container, Row } from 'react-bootstrap'

const PiComponent = ({data,label}) => {
    

  return (
    <Container style={{width:'100%',marginBottom:'40px'}}>
    <Row style={{display:'flex',justifyContent:'space-between' }}>
    <Col sm='12' md='6' lg='6' xl='4' className='mb-4'>
    <SinglePI data={data} flag='status'/>
    
    </Col>
    {label==='بهاربند'&&<Col sm='12' md='6' lg='6' xl='4' className='mb-4'>
    <SinglePI data={data} flag='sens'/>

    </Col>}
    {label!=='بهاربند'&&<Col sm='12' md='6' lg='6' xl='4' className='mb-4'>
    {<SinglePI data={data} flag='count'/>}
    </Col>}
    <Col sm='12' md='6' lg='6' xl='4' className='mb-4'>
    {<SinglePI data={data} flag='cycle'/>}
    </Col>
    </Row>
    </Container>
  )
}

export default PiComponent
